import { Observable } from 'rxjs';
import { Insurance } from '../models/insurance.model';

export abstract class InsuranceRepository {
    abstract toggleInsurance(): Observable<Insurance>;
    abstract getInsurance(): Observable<Insurance>;
}
